import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "methoda_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers["X-Admin-Token"] = token;
  }
  return config;
});

export const setAdminToken = (t) => window.localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => window.localStorage.removeItem(ADMIN_TOKEN_KEY);
export const getAdminToken = () => window.localStorage.getItem(ADMIN_TOKEN_KEY);
